"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.hbcAbIgmMessages = exports.hbsAgMessages = exports.hbsAbMessages = exports.hbcAbIggMessages = exports.HbcAbIgm = exports.HbsAg = exports.HbsAb = exports.HbcAbIgg = void 0;
const schema_1 = require("../../../../schema");
var HbcAbIgg;
(function (HbcAbIgg) {
    HbcAbIgg["POSITIVE"] = "POSITIVE";
    HbcAbIgg["NEGATIVE"] = "NEGATIVE";
    HbcAbIgg["IN_PROGRESS"] = "IN_PROGRESS";
})(HbcAbIgg || (exports.HbcAbIgg = HbcAbIgg = {}));
var HbsAb;
(function (HbsAb) {
    HbsAb["POSITIVE"] = "POSITIVE";
    HbsAb["NEGATIVE"] = "NEGATIVE";
    HbsAb["IN_PROGRESS"] = "IN_PROGRESS";
})(HbsAb || (exports.HbsAb = HbsAb = {}));
var HbsAg;
(function (HbsAg) {
    HbsAg["POSITIVE"] = "POSITIVE";
    HbsAg["NEGATIVE"] = "NEGATIVE";
    HbsAg["IN_PROGRESS"] = "IN_PROGRESS";
})(HbsAg || (exports.HbsAg = HbsAg = {}));
var HbcAbIgm;
(function (HbcAbIgm) {
    HbcAbIgm["POSITIVE"] = "POSITIVE";
    HbcAbIgm["NEGATIVE"] = "NEGATIVE";
    HbcAbIgm["IN_PROGRESS"] = "IN_PROGRESS";
})(HbcAbIgm || (exports.HbcAbIgm = HbcAbIgm = {}));
exports.hbcAbIggMessages = {
    [HbcAbIgg.POSITIVE]: {
        id: "ltx.phaseI.viralSerology.hbvStatus.hbcAbIgg.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [HbcAbIgg.NEGATIVE]: {
        id: "ltx.phaseI.viralSerology.hbvStatus.hbcAbIgg.NEGATIVE",
        defaultMessage: "Negatív"
    },
    [HbcAbIgg.IN_PROGRESS]: {
        id: "ltx.phaseI.viralSerology.hbvStatus.hbcAbIgg.IN_PROGRESS",
        defaultMessage: "Folyamatban"
    }
};
exports.hbsAbMessages = {
    [HbsAb.POSITIVE]: {
        id: "ltx.phaseI.viralSerology.hbvStatus.hbsAb.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [HbsAb.NEGATIVE]: {
        id: "ltx.phaseI.viralSerology.hbvStatus.hbsAb.NEGATIVE",
        defaultMessage: "Negatív"
    },
    [HbsAb.IN_PROGRESS]: {
        id: "ltx.phaseI.viralSerology.hbvStatus.hbsAb.IN_PROGRESS",
        defaultMessage: "Folyamatban"
    }
};
exports.hbsAgMessages = {
    [HbsAg.POSITIVE]: {
        id: "ltx.phaseI.viralSerology.hbvStatus.hbsAg.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [HbsAg.NEGATIVE]: {
        id: "ltx.phaseI.viralSerology.hbvStatus.hbsAg.NEGATIVE",
        defaultMessage: "Negatív"
    },
    [HbsAg.IN_PROGRESS]: {
        id: "ltx.phaseI.viralSerology.hbvStatus.hbsAg.IN_PROGRESS",
        defaultMessage: "Folyamatban"
    }
};
exports.hbcAbIgmMessages = {
    [HbcAbIgm.POSITIVE]: {
        id: "ltx.phaseI.viralSerology.hbvStatus.hbcAbIgm.POSITIVE",
        defaultMessage: "Pozitív"
    },
    [HbcAbIgm.NEGATIVE]: {
        id: "ltx.phaseI.viralSerology.hbvStatus.hbcAbIgm.NEGATIVE",
        defaultMessage: "Negatív"
    },
    [HbcAbIgm.IN_PROGRESS]: {
        id: "ltx.phaseI.viralSerology.hbvStatus.hbcAbIgm.IN_PROGRESS",
        defaultMessage: "Folyamatban"
    }
};
const hbcAbIgg = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HbcAbIgg.POSITIVE),
    schema_1.Schema.singleChoiceItem(HbcAbIgg.NEGATIVE),
    schema_1.Schema.singleChoiceItem(HbcAbIgg.IN_PROGRESS)
])
    .interpretation({ vocab: "ltx", code: "hbc_ab_igg" })
    .tag({ vocab: "snomed", code: "54555005" })
    .tag({ vocab: "loinc", code: "32685-0" });
const hbsAb = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HbsAb.POSITIVE),
    schema_1.Schema.singleChoiceItem(HbsAb.NEGATIVE),
    schema_1.Schema.singleChoiceItem(HbsAb.IN_PROGRESS)
])
    .interpretation({ vocab: "ltx", code: "hbs_ab" })
    .tag({ vocab: "snomed", code: "65911000" })
    .tag({ vocab: "loinc", code: "22322-2" });
const hbsAg = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HbsAg.POSITIVE),
    schema_1.Schema.singleChoiceItem(HbsAg.NEGATIVE),
    schema_1.Schema.singleChoiceItem(HbsAg.IN_PROGRESS)
])
    .interpretation({ vocab: "ltx", code: "hbs_ag" })
    .tag({ vocab: "snomed", code: "47758006" })
    .tag({ vocab: "loinc", code: "5195-3" });
const hbcAbIgm = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(HbcAbIgm.POSITIVE),
    schema_1.Schema.singleChoiceItem(HbcAbIgm.NEGATIVE),
    schema_1.Schema.singleChoiceItem(HbcAbIgm.IN_PROGRESS)
])
    .optional()
    .interpretation({ vocab: "ltx", code: "hbc_ab_igm" })
    .tag({ vocab: "snomed", code: "50506008" })
    .tag({ vocab: "loinc", code: "31204-1" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ hbcAbIgg, hbsAb, hbsAg, hbcAbIgm })
    .interpretation({ vocab: "ltx", code: "hbv_status" })
    .tag({ vocab: "snomed", code: "62889000" })
    .tag({ vocab: "snomed", code: "20135006" })
    .tag({ vocab: "snomed", code: "165994006" });
